import { omit } from 'lodash';
import { FC, ReactElement, ReactNode, useMemo } from 'react';
import ValidatedInput from './ValidatedInput';

const DEFAULT_RENDER_GROUP = (
  name: string,
  inputElements: ReactNode
): ReactElement => {
  return <div id={name}>{inputElements}</div>;
};

interface Props {
  name: string;
  group?: any[];
  onChange?: ((...args: any[]) => any) | null;
  renderGroup?: (name: string, inputElements: ReactNode) => ReactElement;
  [key: string]: any;
}

const DEFAULT_GROUP = [];

const GroupInput: FC<Props> = ({
  name,
  group = DEFAULT_GROUP,
  onChange,
  renderGroup = DEFAULT_RENDER_GROUP,
  ...props
}) => {
  const inputElements = useMemo(() => {
    return group.map((input: unknown, index: number) => {
      // @ts-expect-error
      const value = input?.name && props.value && props.value[input.name];
      return (
        <ValidatedInput
          key={index}
          // @ts-expect-error
          innerRef={input.innerRef}
          // @ts-expect-error
          {...{ ...omit(props, 'helperText', 'label'), ...input }}
          onChange={onChange}
          value={value}
        />
      );
    });
  }, [group, onChange, props]);

  return renderGroup(name, inputElements);
};

export default GroupInput;
